const RECEIPT_EVENT_SEPARATION_MS = 5000;

export class ReceiptRateLimiter {
    private receiptTimeout: NodeJS.Timeout | null;

    constructor () {
        this.receiptTimeout = null;
    }

    sendReceipt = (
        sender: () => Promise<void>,
    ) => {
        // If an older receipt has not yet been sent, clear the timeout and prioritize the newer receipt event
        this.cancelPendingReceiptEvent();

        this.receiptTimeout = setTimeout(async () => {
            this.receiptTimeout = null;
            try {
                await sender();
            } catch (error) {
                console.error('Failed to send message receipt:', error);
            }
        }, RECEIPT_EVENT_SEPARATION_MS);
    };

    // cancel any pending receipt events
    cancelPendingReceiptEvent = () => {
        if (this.receiptTimeout) {
            clearTimeout(this.receiptTimeout);
            this.receiptTimeout = null;
        }
    };

}
